import React from "react";
import {Route, Routes} from "react-router-dom";
import BoardList from "../container/board/BoardList";
import CreateBoard from "../container/board/CreateBoard";
import UpdateBoard from "../container/board/UpdateBoard";
import CreatePost from "../container/board/CreatePost";
import UpdatePost from "../container/board/UpdatePost";

const Board = () => {
  return (
    <Routes>
      <Route path="/*" element={<BoardList />} />
      <Route path="Create" element={<CreateBoard />} />
      <Route path="Edit/:id" element={<UpdateBoard />} />
      <Route path="Post/Create/:id" element={<CreatePost />} />
      <Route path="Post/Edit/:id" element={<UpdatePost />} />
    </Routes>
  );
};

export default Board;
